<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Apps - Categoria | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.status_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="aplicativo">Aplicativo: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.aplicativo.descricao }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AplicativoCategoriaActions from '../../actions/AplicativoCategoriaActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        descricao: '',
        idc_status: '',
        cd_aplicativo: '',
        status_desc: '',
        aplicativo: {
          descricao: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    AplicativoCategoriaActions.obter(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/aplicativo-categorias')
    },
    editar () {
      this.$router.push('/aplicativo-categorias/' + this.id + '/e')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativo-categorias/Detalhes.vue